import React, { useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";

export default function CheckoutForm() {
    let PAYMENT_COMPLETE_URL = "http://localhost:3000/thank-you";
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        // dev code
        console.log("Development mode, PAYMENT_COMPLETE_URL is set to: " + PAYMENT_COMPLETE_URL);
    } else {
        // production code
        PAYMENT_COMPLETE_URL = "https://djfwha6lce1i9.cloudfront.net/thank-you";
        console.log("Production mode, PAYMENT_COMPLETE_URL is set to: " + PAYMENT_COMPLETE_URL);
    }
    const stripe = useStripe();
    const elements = useElements();

    // set some state to track the payment status
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: PAYMENT_COMPLETE_URL,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    return (
        <div className="mt-4">

            <form id="payment-form" onSubmit={handleSubmit}>
                <div className="container">
                    <p className="title is-4">CAETA Case Review</p>
                    <p className="subtitle is-4">Checkout</p>
                    <p>Amount: $300</p>
                    {/* Show any error or success messages */}
                    {message &&
                        <div id="payment-message" className="mb-6">
                            <article className="message is-warning">
                                <div className="message-header">
                                    <p>Payment status</p>
                                    <button className="delete" aria-label="delete"></button>
                                </div>
                                <div className="message-body">
                                    {message}
                                </div>
                            </article>
                        </div>
                    }
                    <PaymentElement id="payment-element" />
                    <div className="mt-2">
                        <img src="/Powered_by_Stripe.svg" alt="Powered by Stripe" />
                    </div>
                    <button className="button is-primary is-pulled-right is-block mt-4 mb-4"
                        disabled={isLoading || !stripe || !elements} id="submit">
                        <span id="button-text">
                            {isLoading ? <div className="spinner" id="spinner"></div> : "Pay $300 now"}
                        </span>
                    </button>
                </div>
            </form>

        </div>

    );
}